import heic2any from "heic2any";
import { useState, useRef, RefObject } from "react"; 
import { showSize } from "src/components/common/functions";
import { MySketch, BgImg, jsonArr, ss } from "src/components/common/types";
import { isArray } from "util";
//--------------------------------------------------------------------------------------------
//params: sketches, setSketches
export default function Sketch({
    sketches, 
    setSketches, 
    limit, 
    showSketch, 
    setShowSketch, 
    buttonClasName, 
    mainClassName
}:{
    sketches: MySketch[], 
    setSketches: ss<MySketch[]>, 
    limit: number, 
    showSketch: boolean, 
    setShowSketch: ss<boolean>, 
    buttonClasName: string, 
    mainClassName: string
}){
    const canvasRef = useRef<HTMLImageElement>(null);
    //--------------------------------------------------------------------------------------------
    const [bgImg, setBgImg] = useState<BgImg>(null);
    const [picData, setPicData] = useState<jsonArr>([]);
    const [currentSketchIndex, setCurrentSketchIndex] = useState(-1);
    //--------------------------------------------------------------------------------------------
    let figI = 1;
    //--------------------------------------------------------------------------------------------
    return(
        <div className = {mainClassName}>
            {sketches.map((sketch:{data: string, caption?: string}, key:number) => (
                currentSketchIndex !== key?
                <div className = "border rounded p-2 mb-2" key = {key}>
                    <figure className = "m-2">
                        <img
                            className = "mx-auto mb-2"
                            style = {{maxWidth: "100%", display: "block"}}
                            src = {sketch.data}
                            onDragStart = {e => e.preventDefault()}
                            alt = ""
                        />
                        <figcaption className = "text-center font-weight-bold">Fig.{figI++} {sketch.caption?"-":""} {sketch.caption} ({showSize(sketch.data.length)})</figcaption>
                    </figure>
                    <div className = "mb-2 mx-auto">
                        <span className = "btn btn-success mr-3" onClick = {e => {
                            if(bgImg || picData.length){
                                if(!window.confirm("there is a sketch on the sketchpad. do you want to override?")){
                                    return;
                                }
                            }
                            setShowSketch(true);
                            setPicData(sketches[key].sketchPicData);
                            setBgImg(sketches[key].sketchBgImg);
                            setCurrentSketchIndex(key);
                        }}>Edit Caption</span>
                        <span className = "btn btn-danger" onClick = {e => {
                            if(!window.confirm("are you sure to delte this image?")) return;
                            setSketches(sketches.filter((dummy:{data: string}, sketchIndex:number) => sketchIndex !== key));
                        }}>Delete</span>
                    </div>
                </div>:<SketchPad
                            canvasRef = {canvasRef}
                            key = {key}
                            setShowSketch = {setShowSketch}
                            sketches = {sketches}
                            setSketches = {setSketches}
                            currentSketchIndex = {currentSketchIndex}
                            setCurrentSketchIndex = {setCurrentSketchIndex}
                            bgImg = {bgImg!}
                            setBgImg = {setBgImg}
                            picData = {picData}
                            setPicData = {setPicData}
                            defaultCaption = {sketch.caption}
                        />
            ))} 
            {currentSketchIndex === -1?(
            showSketch?
            <SketchPad
                canvasRef = {canvasRef}
                setShowSketch = {setShowSketch}
                sketches = {sketches}
                setSketches = {setSketches}
                currentSketchIndex = {currentSketchIndex}
                setCurrentSketchIndex = {setCurrentSketchIndex}
                bgImg = {bgImg!}
                setBgImg = {setBgImg}
                picData = {picData}
                setPicData = {setPicData}
            />:
            <div className = {buttonClasName || "my-4"}>
                <span className = "btn btn-primary" onClick = {() => {
                    setCurrentSketchIndex(-1);
                    if(limit && sketches.length >= limit){
                        window.alert(`You can upload at most ${limit} pictures.`)
                        return;
                    }
                    setShowSketch(true);
                }}>
                    Upload Photos
                </span>
            </div>
            )
            :<></>}
        </div>
    )
}
function SketchPad({
    canvasRef,
    setShowSketch, 
    sketches, 
    setSketches, 
    currentSketchIndex, 
    setCurrentSketchIndex, 
    bgImg, 
    setBgImg, 
    picData, 
    setPicData, 
    defaultCaption
}:{
    canvasRef: RefObject<HTMLImageElement>,
    setShowSketch: ss<boolean>, 
    sketches: MySketch[], 
    setSketches: ss<MySketch[]>, 
    currentSketchIndex: number, 
    setCurrentSketchIndex: ss<number>, 
    bgImg: BgImg, 
    setBgImg: ss<BgImg | null>, 
    picData: jsonArr, 
    setPicData: ss<jsonArr>, 
    defaultCaption?:string
}){
    //--------------------------------------------------------------------------------------------
    const [caption, setCaption] = useState(defaultCaption || "");
    //--------------------------------------------------------------------------------------------
    const saveImg = () => {
        if(currentSketchIndex === -1){
            setSketches([...sketches, {
                sketchPicData: picData, 
                sketchBgImg: bgImg, 
                data: bgImg![0].src,
                caption: caption
            }]);
        }else{
            setSketches(sketches.map((sketch: MySketch, key:number) => (
                currentSketchIndex === key?{
                    sketchPicData: picData, 
                    sketchBgImg: bgImg, 
                    data: bgImg![0].src, 
                    caption: caption
                }:sketch
            )));
        }
        setPicData([]);
        setBgImg(null);
        setShowSketch(false);
        setCurrentSketchIndex(-1);
        
    }
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "border rounded p-2 mb-2">
            <div className = "mb-2">
                <img ref = {canvasRef}
                    src = {sketches[currentSketchIndex]?.data}
                    alt  = ""
                    style = {{display: bgImg || sketches[currentSketchIndex]?"":"none", maxWidth: "100%"}}
                />
            </div>
            <div className = "mb-2">
                {bgImg?<></>:<span className = "pointer btn btn-primary mr-3"
                    onClick = {e => {
                        (e.currentTarget.nextElementSibling! as HTMLElement).click();
                    }}
                >
                    Upload Image
                </span>}
                <input
                    type = "file"
                    accept = "image/png, image/jpeg, image/heic"
                    style = {{display:"none"}}
                    onChange = {async e => {
                        if(bgImg){
                            if(!window.confirm("are you sure to change current background image?")) return;
                        }
                        const target = e.currentTarget;
                        const files = target.files!;
                        if(files.length === 1){

                            // const canvas = document.createElement("canvas");
                            // const context = canvas.getContext("2d");
                            // context!.drawImage(img, img0.width, 0, img0.height);
                            // const dataURL = canvas.toDataURL();

                            const file = files[0];
                            const reader: FileReader = new FileReader();
                            reader.onload = async() => {
                                if(typeof(reader.result) !== "object"){
                                    const img0 = canvasRef!.current!;
                                    img0.src = reader.result;
                                    const img = new Image();
                                    img.src = reader.result;
                                    img.onload = () => {
                                        setBgImg([img, 0, 0, img.width, img.height]);
                                        setPicData([]);
                                    };
                                }
                            }
                            if(file.name.endsWith(".heic")){
                                const blobURL = URL.createObjectURL(file);
                                const blobRes = await fetch(blobURL);
                                const blob = await blobRes.blob();
                                const conversionResult = await heic2any({ blob: blob });
                                if(!Array.isArray(conversionResult)) reader.readAsDataURL(conversionResult);
                                else alert("multiple images is not allowed.");
                            }else{
                                reader.readAsDataURL(file);
                            }
                        }
                        target.value = "";
                    }}
                />
            </div>
            {bgImg?<>
            <div className = "blk5 mb-2" style = {{display: "flex"}}>
                <label className = "mr-3">Caption:</label>
                <input className = "form-control" type = "text" value = {caption} onChange = {e => setCaption(e.currentTarget.value)}/>
            </div>
            <span className = "btn btn-success mr-3" onClick = {() => {saveImg()}}>Save</span>
            </>:null}
            <span className = "btn btn-dark" onClick = {() => {
                setPicData([]);
                setBgImg(null);
                setShowSketch(false);
                setCurrentSketchIndex(-1);
            }}>Close</span>
        </div>
    )    
}